module.exports = __webpack_public_path__ + "static/media/designer-form.b697847c.png";